import { render, staticRenderFns } from "./RedeDescredenciada.vue?vue&type=template&id=6024f206&scoped=true"
import script from "./RedeDescredenciada.vue?vue&type=script&lang=js"
export * from "./RedeDescredenciada.vue?vue&type=script&lang=js"
import style0 from "./RedeDescredenciada.vue?vue&type=style&index=0&id=6024f206&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6024f206",
  null
  
)

export default component.exports